/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMathXPlusX = createReactComponent("math-x-plus-x", "IconMathXPlusX", [
  ["path", { d: "M2 9l6 6", key: "svg-0" }],
  ["path", { d: "M2 15l6 -6", key: "svg-1" }],
  ["path", { d: "M16 9l6 6", key: "svg-2" }],
  ["path", { d: "M16 15l6 -6", key: "svg-3" }],
  ["path", { d: "M10 12h4", key: "svg-4" }],
  ["path", { d: "M12 10v4", key: "svg-5" }]
]);

export { IconMathXPlusX as default };
//# sourceMappingURL=IconMathXPlusX.js.map
